'use client';
import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
  background: ${props => props.theme.colors.background.base};
  display: flex;
  justify-content: center;
  padding: ${props => props.theme.spacing(2, 0)};

  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(4, 0, 2)};
  }
`;

export const CurrentProgress = styled.h3`
  ${props => props.theme.typography.bodyBold}
  color: ${props => props.theme.colors.text.secondary}
`;

export const PromoPillContainer = styled.div`
  position: fixed;
  top: ${props => props.theme.spacing(6)};
  right: ${props => props.theme.spacing(10)};
  @media ${props => props.theme.laptop} {
    right: ${props => props.theme.spacing(20)};
  }
`;
